import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Mentions Légales"
        description="Mentions légales du site lacrea.fr — informations sur l'éditeur, l'hébergement et la propriété intellectuelle."
        path="/mentions-legales"
      />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-primary hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1
          className="text-4xl font-bold mb-8"
        >
          Mentions Légales
        </h1>

        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. Éditeur du site</h2>
            <p className="text-muted-foreground leading-relaxed">
              Le site <strong>lacrea.fr</strong> est édité par :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>
                <strong>Raison sociale :</strong> [Votre raison sociale]
              </li>
              <li>
                <strong>Forme juridique :</strong> [SAS / SARL / Auto-entrepreneur]
              </li>
              <li>
                <strong>SIRET :</strong> [Votre numéro SIRET]
              </li>
              <li>
                <strong>Adresse :</strong> [Votre adresse]
              </li>
              <li>
                <strong>Email :</strong> contact@lacrea.fr
              </li>
              <li>
                <strong>Directeur de la publication :</strong> [Nom du directeur]
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. Hébergement</h2>
            <p className="text-muted-foreground leading-relaxed">
              Le site est hébergé par :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>
                <strong>Hébergeur :</strong> [Nom de l'hébergeur]
              </li>
              <li>
                <strong>Adresse :</strong> [Adresse de l'hébergeur]
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              3. Propriété intellectuelle
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos,
              icônes, etc.) est protégé par les lois relatives à la propriété
              intellectuelle. Toute reproduction, représentation, modification,
              publication ou adaptation de tout ou partie des éléments du site
              est interdite sans l'autorisation écrite préalable de Lacrea.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              4. Limitation de responsabilité
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Lacrea s'efforce de fournir des informations aussi précises que
              possible. Toutefois, Lacrea ne pourra être tenu responsable des
              omissions, des inexactitudes et des carences dans la mise à jour,
              qu'elles soient de son fait ou du fait des tiers partenaires qui
              lui fournissent ces informations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              5. Cookies et données personnelles
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Pour plus d'informations sur la collecte et le traitement de vos
              données personnelles, veuillez consulter notre{" "}
              <Link
                to="/politique-confidentialite"
                className="text-primary hover:underline"
              >
                Politique de confidentialité
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. Droit applicable</h2>
            <p className="text-muted-foreground leading-relaxed">
              Les présentes mentions légales sont soumises au droit français.
              En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
